import {
  CODE_SUBMITED,
  SmsCodeActions,
  SUBMIT_CODE_AGAIN,
  SMS_CODE_VALIDATION_ERROR,
  SET_AGREEMENT_FILE_NAME,
  SET_VERIFICATION_CODE_INPUT_VALUE,
  RESET_VERIFICATION_CODE_FORM,
  SEND_SMS_CODE_AGAIN_VALIDATION_ERROR,
  SET_CURRENT_FULL_SMS_CODE,
  SET_CURRENT_CLIENT_PESEL_RESERVED_ERROR_TEXT,
} from "../actions/code-actions";
import { IContractSignState, TVerificationCodeInputsNamesModel, verificationCodeInputsNames } from "../types";

export enum SMS_CODE_STATUSES {
  SEND_ERROR,
  VALIDATION_ERROR_FULL_CODE_REQUIRED,
  VALIDATION_ERROR_WRONG_CODE,
  ALPHA_NOT_READY
}
export enum SEND_AGAIN_SMS_CODE_STATUSES {
  LIMIT_REACHED,
  CODE_SEND_CORRECTLY,
  SEND_ERROR,
}

export const contractSignIntialState: IContractSignState = {
  verificationCodeInputs: {
    [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_1]: '',
    [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_2]: '',
    [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_3]: '',
    [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_4]: '',
    [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_5]: '',
    [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_6]: '',
  },

  isLimit : false,
  hasError : false,
  hasSmsSendAgainError: false,
  sendedSmsCount: 0,

  agreemenFileName: '',
  currentSmsCodeTextState: null,
  currentSendAgainSmsCodeTextState: null,

  currentFullSmsCode: null,
  currentClientPeselReservedErrorText: null,
};

export function contractSignReducer(
  state: IContractSignState = contractSignIntialState,
  action: SmsCodeActions
) {
  switch (action.type) {
    case SET_VERIFICATION_CODE_INPUT_VALUE: {
      return {
        ...state,
        verificationCodeInputs: {
          ...state.verificationCodeInputs,
          [action.payload.inputName]: action.payload.newValue
        }
      }
    }
    case RESET_VERIFICATION_CODE_FORM: {
      const newState = state

      Object.values(verificationCodeInputsNames).forEach((verificationCodeName: TVerificationCodeInputsNamesModel) => {
        newState.verificationCodeInputs[verificationCodeName] = ''
     })

      return {
        ...newState,
      }
    }
    case CODE_SUBMITED: {
      if(action.payload  !== undefined){
        if(action.payload === false){ // Limit wysyłki kodu sms NIE został osiągnięty
          return {
            ...state,
            currentSendAgainSmsCodeTextState: SEND_AGAIN_SMS_CODE_STATUSES.CODE_SEND_CORRECTLY,
            isLimit: action.payload,
            hasSmsSendAgainError: false,
          }
        }
        else {
          return { // Limit wysyłki kodu sms ZOSTAŁ osiągnięty
            ...state,
            currentSendAgainSmsCodeTextState: SEND_AGAIN_SMS_CODE_STATUSES.LIMIT_REACHED,
            isLimit: action.payload,
            hasSmsSendAgainError: true,
          }
        }
      }

      return state
    }
    case SUBMIT_CODE_AGAIN: {
      return { 
        ...state, 
        sendedSmsCount: state.sendedSmsCount + 1,
      };
    }
    case SMS_CODE_VALIDATION_ERROR: {
      return {
        ...state,
        currentSmsCodeTextState: action.payload,
        hasError: true,
      }
    }
    case SEND_SMS_CODE_AGAIN_VALIDATION_ERROR: {
      return {
        ...state,
        currentSendAgainSmsCodeTextState: action.payload,
        hasSmsSendAgainError: true,
      }
    }
    case SET_AGREEMENT_FILE_NAME: {
      return {
        ...state,
        agreemenFileName: action.payload
      }
    }
    case SET_CURRENT_FULL_SMS_CODE: {
      if(action.payload.length === Object.keys(state.verificationCodeInputs).length){
        return {
          ...state,
          currentFullSmsCode: action.payload
        }
      }

      else return state
    }
    case SET_CURRENT_CLIENT_PESEL_RESERVED_ERROR_TEXT: {
      return {
        ...state,
        currentClientPeselReservedErrorText: action.payload
      }
    }
    default: {
      return state;
    }
  }
}
